import {addBaseQueryParams, addQueryParams, BaseQueryParams} from "@commons/utils/APIParams";
import {config} from "@commons/config.instance";
import axios from "axios";
import {LavoratoreStatusRecord} from "@commons/mapping/LavoratoreStatusRecord";
import {LavoratorePresenzeProprietaULRecord} from "@commons/mapping/LavoratorePresenzeProprietaULRecord";
import {LavoratoreProprietaOrarioRecord} from "@commons/mapping/LavoratoreProprietaOrarioRecord";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {GiustificativoAttestatoINPSRecord} from "@commons/mapping/GiustificativoAttestatoINPSRecord";
import {StatoWeekPLUSRecord} from "@commons/mapping/StatoWeekPLUSRecord";
import {RiepilogoOrePlus} from "@commons/mapping/RiepilogoOrePlus";
import {patch} from "@commons/services/commons.api";
import {PresenzePianificazioneRecord} from "@commons/mapping/PresenzePianificazioneRecord";
import {PresenzeLavoratoreParams} from "@commons/services/lavoratori/lavoratori.presenze.api";
import {MonitorWFData} from "@commons/services/presenze_api/monitorWF.api";
import {PresenzeCausaleWFRecord} from "@commons/mapping/PresenzeCausaleWF";
import {WebApp} from "@commons/Config.class";

interface SavePeriodoPresenzeParams extends Partial<BaseQueryParams> {
    idDip: number,
    chiudiPeriodo?: boolean,
    opeMassiva?: boolean,
    notificaAnomalie?: boolean,
    livelloChiusura?: number,
    pianificazione?: boolean,
    fromNodeJS?: boolean,
}

export const listStatus = (params: PresenzeLavoratoreParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    queryParams.push(`anno=${params.anno}`);
    queryParams.push(`mese=${params.mese}`);
    const url = config.getBaseUrl('FPNet') + `/prePLUS/presenze/${params.idDip}/status-lavoratore?${addQueryParams(queryParams)}`;
    return axios<LavoratoreStatusRecord[]>(url).then(res => res.data);
};

export const listProprietaPresenze = (params: PresenzeLavoratoreParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    queryParams.push(`anno=${params.anno}`);
    queryParams.push(`mese=${params.mese}`);
    const url = config.getBaseUrl('FPNet') + `/prePLUS/presenze/${params.idDip}/proprieta?${addQueryParams(queryParams)}`;
    return axios<LavoratorePresenzeProprietaULRecord[]>(url).then(res => res.data);
};

export const listProprietaOrari = (params: PresenzeLavoratoreParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    queryParams.push(`anno=${params.anno}`);
    queryParams.push(`mese=${params.mese}`);
    const url = config.getBaseUrl('FPNet') + `/prePLUS/presenze/${params.idDip}/hhweek?${addQueryParams(queryParams)}`;
    return axios<LavoratoreProprietaOrarioRecord[]>(url).then(res => res.data);
};

export const listPeriodoPresenze = (params: PresenzeLavoratoreParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    queryParams.push(`anno=${params.anno}`);
    queryParams.push(`mese=${params.mese}`);
    let app: WebApp;
    if (params.calcola) {
        queryParams.push('calcola=true');
        app = 'FPNetJS';
    } else
        app = 'FPNet';
    const url = config.getBaseUrl(app) + `/prePLUS/presenze/${params.idDip}/periodo?${addQueryParams(queryParams)}`;
    return axios<PresenzeGiornataPlusRecord[]>(url).then(res => res.data);
};

export const savePeriodoPresenze = (params: SavePeriodoPresenzeParams, payload: PresenzeGiornataPlusRecord[]) => {
    const queryParams: string[] = addBaseQueryParams(params);
    if (params.chiudiPeriodo)
        queryParams.push(`chiudiPeriodo=${params.chiudiPeriodo}`);
    if (params.opeMassiva)
        queryParams.push(`opeMassiva=${params.opeMassiva}`);
    if (params.notificaAnomalie)
        queryParams.push(`notificaAnomalie=${params.notificaAnomalie}`);
    if (params.livelloChiusura)
        queryParams.push(`livelloChiusura=${params.livelloChiusura}`);
    if (params.pianificazione)
        queryParams.push(`pianificazione=${params.pianificazione}`);
    if (params.fromNodeJS)
        queryParams.push(`fromNodeJS=true`);
    const url = config.getBaseUrl('FPNet') + `/prePLUS/presenze/${params.idDip}/periodo?${addQueryParams(queryParams)}`;
    return patch<PresenzeGiornataPlusRecord[]>(url, payload);
};

// Utilizzata dalla pagina di WF
export const listRichiesteWFPeriodo = (params: PresenzeLavoratoreParams, addWFParams: boolean = false) => {
    const queryParams: string[] = addBaseQueryParams(params);
    queryParams.push(`anno=${params.anno}`);
    queryParams.push(`mese=${params.mese}`);
    if (addWFParams) {
        queryParams.push(`mode=DataTables`); // In HR chiediamo i dati con la modalità DataTables!
        queryParams.push(`view=Grid`);
        queryParams.push(`mostra-tutto=true`);
    }
    const url = config.getBaseUrl('FPNet') + `/prePLUS/presenze/${params.idDip}/causaleWF?${addQueryParams(queryParams)}`;
    return axios<MonitorWFData>(url).then(res => res.data);
};

// Utilizzata dalla pagina di Gestione Presenze
export const listRichiesteWFPeriodoFlat = (params: PresenzeLavoratoreParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    queryParams.push(`anno=${params.anno}`);
    queryParams.push(`mese=${params.mese}`);
    const url = config.getBaseUrl('FPNet') + `/prePLUS/presenze/${params.idDip}/causaleWF?${addQueryParams(queryParams)}`;
    return axios<PresenzeCausaleWFRecord[]>(url).then(res => res.data);
};

export const listVociDiPianificazionePeriodo = (params: PresenzeLavoratoreParams, _addWFParams: boolean = false) => {
    const queryParams: string[] = addBaseQueryParams(params);
    queryParams.push(`anno=${params.anno}`);
    queryParams.push(`mese=${params.mese}`);
    const url = config.getBaseUrl('HR') + `/prePLUS/presenze-pianificazione/${params.idDip}/periodo?${addQueryParams(queryParams)}`;
    return axios<PresenzePianificazioneRecord[]>(url).then(res => res.data);
};

export const listAttestatiINPSPeriodo = (params: PresenzeLavoratoreParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    queryParams.push(`anno=${params.anno}`);
    queryParams.push(`mese=${params.mese}`);
    const url = config.getBaseUrl('FPNet') + `/prePLUS/presenze/${params.idDip}/attestato-inps?${addQueryParams(queryParams)}`;
    return axios<GiustificativoAttestatoINPSRecord[]>(url).then(res => res.data);
};

export const listStatoWeeks = (params: PresenzeLavoratoreParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    queryParams.push(`anno=${params.anno}`);
    queryParams.push(`mese=${params.mese}`);
    queryParams.push(`normalizza=true`);
    const url = config.getBaseUrl('HR') + `/preSTD/presenze/${params.idDip}/status?${addQueryParams(queryParams)}`;
    return axios<StatoWeekPLUSRecord[]>(url).then(res => {
        for (const week of res.data) {
            if (week.totali) // todo Verificare!!!
                week.totali = RiepilogoOrePlus.factory(week.totali);
        }
        return res.data;
    });
};